<template>
    <v-data-table
        :items="tasks"
        :headers="headers"
        :loading="loading"
        no-data-text="Brak kolejnych zaplanowanych zadań"
        :items-per-page="3"
        :mobile-breakpoint="0"
        :hide-default-footer="true"
    >
        <template #item.taskNumber="{item}">
            {{ item.procNumber }}
        </template>
        <template #item.plate="{item}">
            {{ parseEmptyValue(item.procPlateNumber) }}
        </template>
        <template #item.closedFormat="{item}">
            {{ parseEmptyValue(item.orderObject && item.orderObject.closedFormat) }}
        </template>
        <template #item.quantity="{item}">
            {{ item.procTaskQuantity }}
        </template>
        <template #item.volume="{item}">
            {{ parseEmptyValue(item.orderObject && item.orderObject.volume) }}
        </template>
        <template #item.foldedSignaturesQuantity="{item}">
            {{ parseEmptyValue(item.orderObject && item.orderObject.foldedSignaturesQuantity) }}
        </template>
        <template #item.coverStatus="{item}">
            {{ parseEmptyValue(item.orderObject && item.orderObject.coverStatus) }}
        </template>
        <template #item.innerStatus="{item}">
            {{ parseEmptyValue(item.orderObject && item.orderObject.innerStatus) }}
        </template>
        <template #item.date="{item}">
            {{ formatDate(item.procTaskStartTime) }}
        </template>
        <template #item.procTaskDuration="{item}">
            {{ parseDuration(item.procTaskDurationSeconds) }}
        </template>
        <template #item.status="{item}">
            {{ item.procStatus | lowercase }}
        </template>
        <template #item.productionProcessFB="{item}">
            {{ parseEmptyValue(item.productionProcessFB && item.productionProcessFB.name) }}
        </template>
    </v-data-table>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'
import parse from '@/mixins/parse'

export default {
    name: 'NonPrintingTasksTable',
    filters: {
        lowercase(value) {
            return value?.toString().toLowerCase()
        }
    },
    mixins: [
        dateFormatter,
        parse
    ],
    props: {
        tasks: {
            type: Array,
            default: null
        },
        loading: Boolean
    },
    data() {
        return {
            headers: [
                { text: 'Nr zamówienia', value: 'taskNumber', align: 'left' },
                { text: 'Montaż', value: 'plate', align: 'center' },
                { text: 'Format', value: 'closedFormat', align: 'center' },
                { text: 'Nakład', value: 'quantity', align: 'center' },
                { text: 'Objętość', value: 'volume', align: 'center' },
                { text: 'Ilość składek', value: 'foldedSignaturesQuantity', align: 'center' },
                { text: 'Status okładki', value: 'coverStatus', align: 'center' },
                { text: 'Status wnętrz', value: 'innerStatus', align: 'center' },
                { text: 'Zaplanowany start', value: 'date', align: 'center' },
                { text: 'Zaplanowany czas', value: 'procTaskDuration', align: 'center' },
                { text: 'Status', value: 'status', align: 'center' },
                { text: 'Proces', value: 'productionProcessFB', align: 'center' }
            ]
        }
    }
}
</script>